import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MICRO_INGREDIENT_IDS } from '../../../utils/productSuggestions';

const DOT_CLASSES = ['t-bg-navy', 't-bg-navy/70', 't-bg-navy/50', 't-bg-navy/30'];

const formatDose = (ingredient) => {
  if (!ingredient || Number(ingredient.daily_dose) <= 0) return '—';
  const isMicro = MICRO_INGREDIENT_IDS.includes(Number(ingredient.ingredient_id));
  const dose = Number(ingredient.daily_dose) * (isMicro ? 1000 : 1);
  return `${Number(dose.toFixed(4))} ${isMicro ? 'µg' : 'mg'}`;
};

const ComparisonIngredientCard = ({ current, next, index, defaultOpen = false }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const ingredient = next || current;
  const description = ingredient.description || current?.description;
  const hasChanged = Math.abs(Number(current?.daily_dose || 0) - Number(next?.daily_dose || 0)) > 0.000001;

  return (
    <div
      className={`t-border t-rounded-lg t-mb-1.5 t-bg-white t-overflow-hidden t-transition-colors ${
        isOpen ? 't-border-navy/30' : 't-border-g200 hover:t-border-navy/30'
      }`}
    >
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        className="t-flex t-w-full t-items-center t-gap-3 t-border-0 t-bg-transparent t-px-3 t-py-2.5 t-text-left"
      >
        <span
          className={`t-w-2.5 t-h-2.5 t-rounded-full t-flex-shrink-0 ${DOT_CLASSES[index % DOT_CLASSES.length]}`}
        />
        <span className="t-flex-1 t-min-w-0 t-text-[13px] t-font-bold t-text-navy t-leading-snug t-break-words">
          {ingredient.ingredient}
        </span>
        <span className="t-flex t-items-center t-gap-2 t-flex-shrink-0">
          <span className="t-w-[64px] t-break-words t-text-xs t-font-semibold t-text-navy t-text-right">
            {formatDose(current)}
          </span>
          <span
            className={`t-w-[64px] t-break-words t-text-xs t-text-right ${hasChanged ? 't-font-semibold t-text-quiz-teal' : 't-text-navy/60'}`}
          >
            {formatDose(next)}
          </span>
          <span className="t-text-[10px] t-text-navy/50 t-w-2.5" aria-hidden="true">
            {isOpen ? '▲' : '▼'}
          </span>
        </span>
      </button>
      {isOpen && description && (
        <div className="t-border-t t-border-g200 t-px-3 t-pb-3">
          <div className="t-bg-navy/5 t-rounded-lg t-px-3 t-py-2 t-mt-2">
            <p className="!t-m-0 !t-mb-1 t-text-[10px] t-font-bold t-text-navy t-uppercase t-tracking-wide t-text-center">
              {ingredient.manually_added
                ? t('IngredientCard_YouAddedThis')
                : t('IngredientCard_WhyWeAddedThis')}
            </p>
            <p className="!t-m-0 t-text-[12px] t-text-navy t-leading-relaxed">{description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComparisonIngredientCard;
